import queryClient from '@/shared/lib/react-query/queryClient';

import discoveryStore from '../model/store';

export async function resetUsers() {
  await queryClient.cancelQueries({queryKey: ['discovery']});
  await queryClient.invalidateQueries({queryKey: ['discovery']});
  discoveryStore.cleanUp();
}
